import React, { useEffect, useState } from "react";
import ProfileTable from "../../components/Profile/ProfileTable";
import { getReportsByUser } from "../../services/reports";
import { Typography } from "antd";


const { Title, Text } = Typography;


const Profile = () => {
  const [pdfs, setPdfs] = useState([]);
  const [pdfCount, setPdfCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const[update,setUpdate]=useState(false);
 

  const fetchReports = async (page = 1, pageSize = 5) => {
    try {
      setLoading(true);
      const response = await getReportsByUser(page);
      console.log(response);
      if (response.success) {
        setPdfs(response.data);
        setPagination({
          current: page,
          pageSize,
          total: response.total,
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchReports(pagination.current, pagination.pageSize);

    if(update){
        setUpdate(false)
    }
  }, [update]);

  const handleTableChange = (paginationInfo) => {
    fetchReports(paginationInfo.current, paginationInfo.pageSize);
  };

  return (
    <section className="bg-white min-h-[calc(100vh-90px)] px-10 py-8">
         <div className="mb-8">
        <Title level={3} className="!m-0 !text-[#1c5a85] font-semibold">
         User records
        </Title>
        <Text className="text-gray-500 text-sm">
          Get your previous and latest pdfs here
        </Text>
      </div>
      <ProfileTable pdfs={pdfs} loading={loading} pagination={pagination} handleTableChange={handleTableChange} setUpdate={setUpdate} />
    </section>
  );
};

export default Profile;
